import { render, staticRenderFns } from "./waitingPopupMessage.vue?vue&type=template&id=45c2d679&scoped=true&"
import script from "./waitingPopupMessage.vue?vue&type=script&lang=js&"
export * from "./waitingPopupMessage.vue?vue&type=script&lang=js&"
import style0 from "./waitingPopupMessage.vue?vue&type=style&index=0&id=45c2d679&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2d679",
  null
  
)

export default component.exports